/* Custom Mega Menu interactions - lightweight loader */
(function () {
    const DESKTOP_QUERY = '(min-width: 990px)';

    const coreState = {
        loadPromise: null,
        loaded: false,
        prefetched: false,
    };

    const getCoreSrc = () => {
        const script = document.querySelector('script[data-eeg-header-menu-core-src]');
        if (script && script.dataset && script.dataset.eegHeaderMenuCoreSrc) {
            return script.dataset.eegHeaderMenuCoreSrc;
        }
        return '';
    };

    const canPrefetchAssets = () => {
        if (window.EEGAssetLoader && typeof window.EEGAssetLoader.canPrefetchAssets === 'function') {
            return window.EEGAssetLoader.canPrefetchAssets();
        }
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return true;
        if (connection.saveData) return false;
        if (typeof connection.effectiveType === 'string' && connection.effectiveType.includes('2g')) return false;
        return true;
    };

    const prefetchCore = () => {
        if (coreState.prefetched) return;
        const src = getCoreSrc();
        if (!src || !document.head) return;
        if (!canPrefetchAssets()) return;

        coreState.prefetched = true;
        if (document.querySelector('link[data-eeg-header-menu-core-prefetch]')) return;

        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'script';
        link.href = src;
        link.setAttribute('data-eeg-header-menu-core-prefetch', 'true');
        document.head.appendChild(link);
    };

    let cleanupListeners = null;

    const loadCore = () => {
        if (coreState.loaded) return Promise.resolve();
        if (coreState.loadPromise) return coreState.loadPromise;
        const src = getCoreSrc();
        if (!src || !document.body) return Promise.resolve();

        coreState.loadPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-eeg-header-menu-core]');
            if (existing) {
                if (existing.getAttribute('data-eeg-loaded') === 'true') {
                    coreState.loaded = true;
                    resolve();
                    return;
                }
                existing.addEventListener('load', () => {
                    coreState.loaded = true;
                    resolve();
                }, { once: true });
                existing.addEventListener('error', () => {
                    coreState.loadPromise = null;
                    reject(new Error('Header menu core failed to load.'));
                }, { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.setAttribute('data-eeg-header-menu-core', 'true');
            script.onload = () => {
                script.setAttribute('data-eeg-loaded', 'true');
                coreState.loaded = true;
                resolve();
            };
            script.onerror = () => {
                coreState.loadPromise = null;
                reject(new Error('Header menu core failed to load.'));
            };
            document.body.appendChild(script);
        }).then(() => {
            if (cleanupListeners) {
                cleanupListeners();
                cleanupListeners = null;
            }
        });

        return coreState.loadPromise;
    };

    window.EEGHeaderMenuLoader = window.EEGHeaderMenuLoader || {};
    if (typeof window.EEGHeaderMenuLoader.load !== 'function') {
        window.EEGHeaderMenuLoader.load = loadCore;
    }
    if (typeof window.EEGHeaderMenuLoader.prefetch !== 'function') {
        window.EEGHeaderMenuLoader.prefetch = prefetchCore;
    }

    const triggerSelector = '.mega-menu-host--enhanced .mega-menu__trigger';
    const navListSelector = '.header__nav-list';

    let isBound = false;
    let mediaQuery = null;

    const isTriggerHovered = (trigger) => {
        return !!(trigger && typeof trigger.matches === 'function' && trigger.matches(':hover'));
    };

    const scheduleIdlePrefetch = () => {
        if (!getCoreSrc()) return;
        if (!canPrefetchAssets()) return;
        const start = () => prefetchCore();
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(start, { timeout: 2500 });
        } else {
            window.setTimeout(start, 1200);
        }
    };

    const setupDesktop = () => {
        if (isBound || coreState.loaded) return;
        if (!getCoreSrc()) return;

        const triggers = Array.from(document.querySelectorAll(triggerSelector));
        if (!triggers.length) return;

        const navList = document.querySelector(navListSelector);

        const handlePrefetch = () => {
            prefetchCore();
        };

        const handlePointerEnter = (event) => {
            if (coreState.loaded) return;
            const trigger = event.currentTarget;
            loadCore()
                .then(() => {
                    if (!trigger || !trigger.isConnected) return;
                    // 只有鼠标仍停留在当前菜单项上，才补发悬停事件。
                    if (!isTriggerHovered(trigger)) return;
                    trigger.dispatchEvent(new Event('mouseenter'));
                })
                .catch(() => {});
        };

        const handleFocus = (event) => {
            if (coreState.loaded) return;
            const trigger = event.currentTarget;
            loadCore()
                .then(() => {
                    if (!trigger || !trigger.isConnected) return;
                    if (document.activeElement === trigger) {
                        trigger.dispatchEvent(new Event('focus'));
                    }
                })
                .catch(() => {});
        };

        const handleClick = (event) => {
            if (coreState.loaded) return;
            const trigger = event.currentTarget;
            event.preventDefault();
            loadCore()
                .then(() => {
                    if (!trigger || !trigger.isConnected) return;
                    trigger.click();
                })
                .catch(() => {});
        };

        const handleKeydown = (event) => {
            if (coreState.loaded) return;
            const trigger = event.currentTarget;
            const key = event.key || '';
            const code = (event.code || '').toUpperCase();
            if (key !== ' ' && key !== 'Enter' && code !== 'SPACE' && code !== 'ENTER') return;
            event.preventDefault();
            loadCore()
                .then(() => {
                    if (!trigger || !trigger.isConnected) return;
                    trigger.click();
                })
                .catch(() => {});
        };

        if (navList) {
            navList.addEventListener('pointerover', handlePrefetch, { passive: true });
            navList.addEventListener('focusin', handlePrefetch);
        }

        triggers.forEach((trigger) => {
            trigger.addEventListener('mouseenter', handlePointerEnter, { passive: true });
            trigger.addEventListener('focus', handleFocus);
            trigger.addEventListener('click', handleClick);
            trigger.addEventListener('keydown', handleKeydown);
        });

        scheduleIdlePrefetch();

        isBound = true;
        cleanupListeners = () => {
            if (navList) {
                navList.removeEventListener('pointerover', handlePrefetch);
                navList.removeEventListener('focusin', handlePrefetch);
            }
            triggers.forEach((trigger) => {
                trigger.removeEventListener('mouseenter', handlePointerEnter);
                trigger.removeEventListener('focus', handleFocus);
                trigger.removeEventListener('click', handleClick);
                trigger.removeEventListener('keydown', handleKeydown);
            });
            isBound = false;
        };
    };

    const handleBreakpoint = () => {
        if (!mediaQuery) return;
        if (mediaQuery.matches) {
            setupDesktop();
        } else if (cleanupListeners) {
            cleanupListeners();
            cleanupListeners = null;
        }
    };

    const init = () => {
        mediaQuery = window.matchMedia(DESKTOP_QUERY);
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleBreakpoint);
        } else if (mediaQuery.addListener) {
            mediaQuery.addListener(handleBreakpoint);
        }
        handleBreakpoint();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
